import { createContext, FC, useCallback, useState } from "react";
import { ReactElementProps } from "../../types";
import { PhoneNumber, PhoneNumberClient } from "@ciptex/phonenumber-sdk";
import { PhoneNumberProviderContextType } from "../../types/ciptex-sdk";

export const PhoneNumberProviderContext = createContext<PhoneNumberProviderContextType>(null!);

export const PhoneNumberProvider: FC<ReactElementProps> = ({ children }: ReactElementProps) => {
	const [phoneNumberClient, setPhoneNumberClient] = useState<PhoneNumberClient>();

	const connect = useCallback(
		(token: string) => {
			try {
				const client = new PhoneNumberClient({ TOKEN: token });
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				window.phoneNumberClient = client;
				setPhoneNumberClient(client);
			} catch (error: any) {
				console.error(error)
			}
		}, []);

	const list = useCallback(async (tags: string): Promise<PhoneNumber[]> => {
		if(phoneNumberClient)
		{
			return phoneNumberClient.phonenumber.list(500, undefined, tags);
		}
		else
		{
			console.log("[CIPTEX] NO PhoneNumber Client");
			return [];
		}

	}, [ phoneNumberClient ]);

	return <PhoneNumberProviderContext.Provider value={{ connect, list }}>{children}</PhoneNumberProviderContext.Provider>;
}